<template>
	<div>
        <table class="table table-bordered table-striped table-condensed">
            <thead>
                <tr>
                    <th>&nbsp;</th>
                    <th>Timeslot</th>
                    <th>Number Required</th>
                    <th>Hours</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(timeslot, index) in timeslots">
                    <td class="row-actions row-actions-2-btn">
                        <button @click="editTimeslot(timeslot)" class="btn btn-sm btn-primary"><span class="glyphicon glyphicon-pencil" aria-hidden="true"></span></button>
                        <button @click="removeJob(timeslot.id)" class="btn btn-sm btn-danger"><span class="glyphicon glyphicon-trash" aria-hidden="true"></span></button>
                    </td>
                    <td>{{ timeslot.timeslot_name }}</td>
                    <td><span class="required_volunteers">{{ timeslot.number_required }}</span></td>
                    <td><span class="required_hours">{{ timeslot.hours }}</span></td>
                </tr>
                <tr v-show="!addMode">
                	<td colspan="4">
                		<button class="btn btn-sm btn-primary pull-right" @click="addTimeslot" v-show="!addMode"><i class="glyphicon glyphicon-plus"></i></button>
                	</td>
                </tr>
                <tr v-if="form">
                	<td class="row-actions row-actions-2-btn">
        		        <form @submit.prevent="currentTimeslot ? updateTimeslot() : saveNewTimeslot()" class="form-inline">
                		<button class="btn btn-sm btn-danger" @click="cancelForm" v-show="addMode"><span class="glyphicon glyphicon-ban-circle" aria-hidden="true"></span></button>
                    		<button type="submit" class="btn btn-sm btn-success"><span class="glyphicon glyphicon-floppy-disk" aria-hidden="true"></span></button>
                    	</form>
                	</td>
                	<td><input class="form-control timeslot_name" v-model="form.timeslot_name" placeholder="Timeslot Name" /></td>
                	<td><input type="number" class="form-control required_volunteers" v-model="form.number_required" size="4"></td>
                	<td><input type="number" class="form-control required_hours" v-model="form.hours" size="4"></td>
                </tr>
            </tbody>
        </table>
	</div>
</template>
<style scoped>
	.required_hours {
		width: 120px;
	}
	.required_volunteers {
		width: 120px;
	}
    .timeslot_name {
        width: 200px;
    }
</style>
<script>
    import Form from '../utils/Form';
	export default {
		props: [
		    'eventId',
            'jobId'

        ],

		data: function () {
			return {
				addMode: false,
				currentTimeslot: null,
				timeslots: [],
                form: null,
                buttonLabel: this.currentTimeslot ? 'Update Timeslot' : 'Save New Timeslot'
			}
		},
        mounted() {
            this.getTimeslots();
        },

		methods: {
			addTimeslot() {
				console.log('addTimeslot');
				this.addMode = true;
				this.currentTimeslot = null;
				this.setupForm();
			},
			editTimeslot(timeslot) {
				console.log('editTimeslot');
				this.addMode = true;
				this.currentTimeslot = timeslot;
				this.setupForm();
			},
			cancelForm() {
				console.log('cancelForm');
				this.addMode = false;
				this.currentTimeslot = null;
				this.form = null;
                this.$message({message: 'Your changes have been cancelled.', type: 'success'});
			},
			setupForm() {
				console.log('setupForm');
				this.form = new Form({
                    timeslot_name: this.currentTimeslot ? this.currentTimeslot.timeslot_name : null,
                    number_required: this.currentTimeslot ? this.currentTimeslot.number_required : null,
                    hours: this.currentTimeslot ? this.currentTimeslot.hours : true
                });
			},

			reloadTimeslots() {
				this.addMode = false;
				this.currentTimeslot = null;
				this.getTimeslots();
			},



            getTimeslots() {
                axios.get(`/api/v1/club_events/${this.eventId}/jobs/${this.jobId}/timeslots`).then((response) => {
                    this.timeslots = response.data;
                }).catch((error) => {
                    this.$message({message: 'There was a problem loading timeslots.', type: 'error'});
                });
            },
            formatDate(theDate) {
                return moment(theDate).format("DD/MM/YYYY")
            },

            removeJob(id) {
                axios.delete(`/api/v1/club_events/${this.eventId}/jobs/${this.jobId}/timeslots/${id}`)
                    .then(response => {
                        this.getTimeslots();
                    })
                    .catch(error => {
                        this.$message({message: 'There was a problem removing the job.', type: 'error'});
                    });
            },
            saveNewTimeslot() {
				console.log('saveNewTimeslot');
                this.form.post(`/api/v1/club_events/${this.eventId}/jobs/${this.jobId}/timeslots`)
                    .then(response => {
                    	this.form = null;
                    	this.reloadTimeslots()
                    })
                    .catch(error => {
                        this.$message({message: 'There was a problem saving the timeslot.', type: 'error'});
                    });
            },

            updateTimeslot() {
				console.log('updateTimeslot');
                this.form.put(`/api/v1/club_events/${this.eventId}/jobs/${this.jobId}/timeslots/${this.currentTimeslot.id}`)
                    .then(response => {
                    	this.form = null;
                    	this.reloadTimeslots()
                    })
                    .catch(error => {
                        this.$message({message: 'There was a problem saving the timeslot.', type: 'error'});
                    });
            },
		},
        destroyed() {
            this.form = null;
        }
	}
</script>

